import { render, staticRenderFns } from "./SideLeft_List.vue?vue&type=template&id=0a56a73b"
import script from "./SideLeft_List.vue?vue&type=script&lang=js"
export * from "./SideLeft_List.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports